import { render, staticRenderFns } from "./NotificationMenu.vue?vue&type=template&id=5701e46a&scoped=true&"
import script from "./NotificationMenu.vue?vue&type=script&lang=ts&"
export * from "./NotificationMenu.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationMenu.vue?vue&type=style&index=0&id=5701e46a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5701e46a",
  null
  
)

export default component.exports